import { hexToRGB } from '.'

export function parseCssVars(category) {
  let image_url = '/assets/img/000_Class_pic_Basic.jpg'
  let color = '#ffffff'

  if (category) {
    if (category.image_url) {
      image_url = encodeURI(decodeURI(category.image_url))
    }
    if (category.background_color) {
      color = category.background_color
    }
  }
  return '--image-url: url(' + image_url + '); ' +
      '--color: ' + color + ';' +
      '--color-rgb: ' + hexToRGB(color) + ';'
}
